var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldColorfilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.46A5.93 5.93 0 0 1 8 22c-3.31 0-6-2.69-6-6a6 6 0 0 1 3.04-5.21 7.49 7.49 0 0 0 4.98 4.44c.63.18 1.29.27 1.98.27.68 0 1.32-.09 1.94-.25.04.24.06.5.06.75 0 1.77-.77 3.37-2 4.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.58 10.21a6.019 6.019 0 0 1-4 3.58c-.5.14-1.03.21-1.58.21s-1.08-.07-1.58-.21A5.993 5.993 0 0 1 6 8c0-3.31 2.69-6 6-6a6.005 6.005 0 0 1 5.58 8.21zM16 22c-.99 0-1.93-.24-2.75-.67A7.394 7.394 0 0 0 15.5 16c0-.34-.03-.68-.08-1l-.002-.015a.5.5 0 0 1 .188-.476c1.801-1.387 2.92-2.627 3.354-3.72A6 6 0 0 1 22 16c0 3.31-2.69 6-6 6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldColorfilter);
export default __webpack_public_path__ + "static/media/vuesax-bold-colorfilter.6514fdc1eb40df16df7d034364526a31.svg";
export { ForwardRef as ReactComponent };